import { Component, input, output } from '@angular/core';
import { HlmButton } from '../../../ui/button/src';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideUpload } from '@ng-icons/lucide';
import { HlmIcon } from '../../../ui/icon/src';

@Component({
    selector: 'app-file-upload-button',
    template: `
    <input #uploader type="file" hidden [accept]="acceptedFiles()" (change)="onFileChange($event)" />

    <button [disabled]="disabled()" hlmBtn variant="outline" (click)="uploader.click()">
      {{ buttonText() }} <ng-icon hlm name="lucideUpload" />
    </button>
  `,
    styles: [
        `
      :host {
        display: inline-flex;
        align-items: center;
      }
    `,
    ],
    imports: [HlmButton, NgIcon, HlmIcon],
    providers: [provideIcons({ lucideUpload })]
})
export class FileUploadButtonComponent {
  readonly buttonText = input<string>('Upload a file');

  readonly acceptedFiles = input<string[]>(['*']);

  readonly disabled = input<boolean>(false);

  readonly selectedFile = output<File>();

  constructor() {}

  onFileChange(data: Event) {
    const element = data.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;
    if (fileList && fileList.length) {
      this.selectedFile.emit(fileList[0]);
    }
  }
}
